export default function NotificationIcon() {
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M12.5007 14.1667H16.6673L15.4965 12.9958C15.3393 12.8386 15.2145 12.6519 15.1295 12.4464C15.0444 12.2409 15.0006 12.0207 15.0007 11.7983V9.16667C15.0008 8.13245 14.6803 7.12362 14.0833 6.27907C13.4864 5.43453 12.6423 4.7958 11.6673 4.45083V4.16667C11.6673 3.72464 11.4917 3.30072 11.1792 2.98816C10.8666 2.67559 10.4427 2.5 10.0007 2.5C9.55862 2.5 9.1347 2.67559 8.82214 2.98816C8.50958 3.30072 8.33398 3.72464 8.33398 4.16667V4.45083C6.39232 5.1375 5.00065 6.99 5.00065 9.16667V11.7992C5.00065 12.2475 4.82232 12.6783 4.50482 12.9958L3.33398 14.1667H7.50065M12.5007 14.1667H7.50065M12.5007 14.1667V15C12.5007 15.663 12.2373 16.2989 11.7684 16.7678C11.2996 17.2366 10.6637 17.5 10.0007 17.5C9.33761 17.5 8.70172 17.2366 8.23288 16.7678C7.76404 16.2989 7.50065 15.663 7.50065 15V14.1667'
        stroke='currentColor'
        strokeWidth='1.3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
